export default {
  data() {
    return {
      scrollLock: false,
      scrollTimer: null,
      duration: 300
    };
  },
  methods: {
    async animateScroll(container, diff) {
      const duration = this.duration;
      const from = container.scrollLeft;
      let to = from + diff;
      if (to < 0) to = 0;
      if (to > container.scrollWidth - container.clientWidth) {
        to = container.scrollWidth - container.clientWidth;
      }
      const time = Date.now();
      await new Promise(res => {
        clearInterval(this.scrollTimer);
        this.scrollTimer = setInterval(
          () => this.scroll(res, container, from, to, time, time + duration),
          16
        );
      });
      clearInterval(this.scrollTimer);
    },
    scroll(resolve, target, startPos, endPos, startTime, endTime) {
      const time = Date.now();
      if (time > endTime) {
        resolve();
      } else {
        target.scrollLeft =
          startPos +
          (endPos - startPos) *
            (1 - Math.pow((time - startTime) / (endTime - startTime) - 1, 2));
        // target.scrollLeft = startPos + (endPos - startPos) * (Math.pow((time - startTime) / (endTime - startTime)-1, 3)+1);
      }
    }
  }
};
